import {LiveReducer, ReducerFromState} from "../../../@types/reducers";
import {LiveSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<LiveReducer>): LiveSettingsObject => state.live.settings;